import { c } from "react-compiler-runtime";
import { memo, useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import isEqual from "lodash/isEqual";
const arePropsEqual = (oldProps, newProps)=>isEqual(oldProps, newProps);
const UpdateStatePlugin = /*#__PURE__*/ memo((t0)=>{
    const $ = c(4);
    const { state } = t0;
    const [editor] = useLexicalComposerContext();
    let t1;
    let t2;
    if ($[0] !== editor || $[1] !== state) {
        t1 = ()=>{
            if (state) {
                const editorState = editor.parseEditorState(state);
                editorState.read(()=>{
                    editor.setEditorState(editorState);
                });
            }
        };
        t2 = [
            editor,
            state
        ];
        $[0] = editor;
        $[1] = state;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    useEffect(t1, t2);
    return null;
}, arePropsEqual);
export { UpdateStatePlugin };
